/**
 * Media Carousel: Splide init + Card Spotlight (CSS transitions) for 288-media-carousel section.
 * Note: card hover (scale wrapper + media) is handled in CSS — Splide loop clones make
 * JS per-element binding unreliable; CSS hover matches originals and clones uniformly.
 */
(function () {
  const SECTION_SELECTOR = ".media-carousel";
  const SPLIDE_SELECTOR = ".media-carousel__splide";

  function whenReady(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  function initSection(section) {
    const splideEl = section.querySelector(SPLIDE_SELECTOR);
    if (!splideEl || typeof window.Splide === "undefined") return;

    const splide = new window.Splide(splideEl, {
      type: "loop",
      perPage: 4.5,
      perMove: 1,
      focus: "center",
      snap: 1,
      updateOnMove: true,
      gap: "var(--ctx-rhythm, 1rem)",
      padding: { left: "0", right: "0" },
      arrows: false,
      flickPower: 200,
      flickMaxPages: 1,
      pagination: false,
      autoplay: false,
      easing: "cubic-bezier(0, 0.55, 0.45, 1)",
      breakpoints: {
        1200: { perPage: 3.5 },
        990: { perPage: 2.5 },
        749: {
          perPage: 1.5,
          autoplay: false,
          interval: 3000,
          pauseOnHover: true,
          pauseOnFocus: true,
        },
      },
      i18n: {
        prev: "Previous slide",
        next: "Next slide",
      },
    });

    splide.mount();

    function showFirstFrame(video) {
      video.removeAttribute("poster");
      if (video.readyState >= 1) {
        video.currentTime = 0.001;
      } else {
        video.addEventListener(
          "loadedmetadata",
          () => {
            video.currentTime = 0.001;
          },
          { once: true },
        );
      }
    }

    function syncVideos() {
      const slides = splideEl.querySelectorAll(".splide__slide");
      slides.forEach((slide) => {
        const video = slide.querySelector("video");
        if (!video) return;
        if (slide.classList.contains("is-active")) {
          video.currentTime = 0;
          video.play().catch(() => {});
        } else {
          video.pause();
          showFirstFrame(video);
        }
      });
    }

    splide.on("moved", syncVideos);
    syncVideos();
  }

  function run(attempt) {
    const n = typeof attempt === "number" ? attempt : 0;
    // Splide loads from a CDN (defer); if it isn't ready yet, retry briefly.
    // Bounded so a blocked CDN (ad blocker) doesn't loop forever — the CSS
    // fallback keeps the cards visible if Splide never arrives.
    if (typeof window.Splide === "undefined") {
      if (n < 50) window.setTimeout(() => run(n + 1), 100);
      return;
    }
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  whenReady(run);

  document.addEventListener("shopify:section:load", function (e) {
    const section =
      e.target.querySelector(SECTION_SELECTOR) ||
      (e.target.matches(SECTION_SELECTOR) ? e.target : null);
    if (section) initSection(section);
  });
})();
